import React from "react";
import AnswerMultiChoice from "../../Shared/AnswerMultiChoice";
import AnswerRadio from "../../Shared/AnswerRadio";

import "./CategoryQuestions.scss";

const CategoryQuestion = ({ questions }) => {
	return (
		<div className="category-questions-container">
			<div className="box">
				<div className="box-header">
					<h2 className="box-title">Questions</h2>
				</div>
				{questions.map((question, index) => (
					<div key={index} className="category-questions-item">
						<h2>{`${index + 1}. ${question.name}`}</h2>
						<div className="answers-section">
							{question.question_kind === "radio" ? (
								<AnswerRadio question={question} />
							) : (
								<AnswerMultiChoice question={question} />
							)}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default CategoryQuestion;
